import React from "react";
import CartProvider from "../../providers/CartProvider";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppProps } from "../BaseApp";
import OrderProvider from "../../providers/OrderProvider";
import CustomToastContainer from "../../../shared/ui/custom-toast-container";
import { QueryClientProvider } from "@tanstack/react-query";
import Checkout from "../../../pages/checkout";
import AnalyticsProvider from "app/providers/AnalyticsProvider";
import PaymentProvider from "pages/payment/providers/PaymentProvider";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Toaster } from "react-hot-toast";
import { queryClient } from "../queryClient";

const App: React.FC<AppProps> = (props, context) => {
  const getBasename = (): string => {
    return props.configuration.basename || "webshop/checkout";
  };

  return (
    <div className="gg">
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AnalyticsProvider>
            <CartProvider>
              <OrderProvider>
                <PaymentProvider>
                  <CustomToastContainer />
                  <div>
                    <Toaster />
                  </div>
                  <Routes>
                    <Route path={getBasename()} element={<Checkout />} />
                  </Routes>
                </PaymentProvider>
              </OrderProvider>
            </CartProvider>
          </AnalyticsProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </BrowserRouter>
    </div>
  );
};

export default App;
